<template>
    <Descriptions
        bordered
        :column="4"
    >
        <DescriptionsItem
            :span="4"
            :label="$t('targetPopulation')"
        >
            {{ measure.targetPopulation }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('numberOfDimensions')"
        >
            1
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('numberOfItems')"
        >
            {{ measure.items.length }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('numberOfResponsesMinimum')"
        >
            {{ measure.settings.minimumQuestionsAsked }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('numberOfResponsesMaximum')"
        >
            {{ measure.settings.maximumQuestionsAsked }}
        </DescriptionsItem>
    </Descriptions>
</template>

<script>
import { Descriptions } from 'ant-design-vue';
export default {
    name: 'Meta',
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
    },
    props: {
        measure: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>